import { mapEntityProperties } from "@/utils/mapEntityProperties"
import { OrdersStreamEntity } from "../../domain/entities/OrdersStreamEntity"

 
export class OrdersStreamModel extends OrdersStreamEntity {
  constructor(dataDto: OrdersStreamEntity) {
    super()
    mapEntityProperties<OrdersStreamEntity>(this, dataDto)
  }
}
